module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAAAMCAYAAACZW2gkAAAAAXNSR0IArs4c6QAAAMhJREFUWAntl7ENAyEMRc+p0qWO0rNCRsgUabNjRsgKVKxwJRXxLywhhzsp0uHqIyGQOfmj/zgLloUtzIGc8x19JCijIGPHOwAArbU3MovII6X06VUIondj0twgKIgLJBTE6mEQxCTzLa2HYHEPgyDMmQnjFgST6mFIKeVaa33ZIsfDHLhppqeWo/NeRoNx2vuIa3EOsDRN9Pqv0jRxH0ytDmzBsJJk11j+EQHHxcPwELAFgggAAQmDgbmC+HnQIc4W5ABgoI/kviK7beU1zd31AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/info_left.png
// module id = cz9D
// module chunks = 1